import { createContext } from 'react'

export const MinimizedModalsContext = createContext(null)
